<style scoped>
  .my-list-menu-item {
    font-size: 14px;
    user-select: none;
    position: relative;
    overflow: hidden;
  }

  ul {
      min-height: 30px;
    list-style: none;
    overflow: hidden;
    border-bottom: 1px solid rgba(226, 226, 226, 1);
    padding: 15px 0px;
  }

  ul:not(.select) {
    padding-left: 120px;
  }

  .title {
    position: absolute;
    left: 0;
    width: 80px;
    white-space: nowrap;
    overflow: hidden;
  }

  ul.select {
    background-color: rgba(249, 249, 249, 1);
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.08);
  }

  li {
    padding: 0px 20px;
    line-height: 30px;
    float: left;
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    cursor: pointer;
  }

  li:not(.title):hover {
    color: #606266;
  }

  li.active {
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
  }

  li.active i:hover {
    color: #2F70D4;
  }

  li.active span:hover {
    color: #2F70D4;
  }

  li.title {
    color: rgba(51, 51, 51, 1);
    font-size: 14px;
    text-align: left;
    font-family: PingFang-SC-Bold;
    font-weight: bold;
  }
</style>

<template>
  <div class="my-list-menu-item">
    <ul>
      <li class="title" v-on:click="itemClickHandler(data)">
        {{ data.subject_name }}
      </li>
      <li v-for="(item, index) in data.child" v-bind:key="index" v-bind:class="itemActiveClass(item)">
        <span v-on:click="itemClickHandler(item)">{{ item.subject_name }}</span>
        <i v-if="item.child && item.child.length" v-bind:class="itemIClass(item)"
          v-on:click="itemArrowClickHandler(item)" />
      </li>
    </ul>
    <ul v-show="select.child && select.child.length" class="select">
      <li v-for="(item, index) in select.child" v-on:click="itemClickHandler(item)" v-bind:key="index">
        {{ item.subject_name }}
      </li>
    </ul>
  </div>
</template>

<script>
  import Cookies from 'js-cookie'
  export default {
    name: 'MyListMenuItem',
    props: {
      data: {
        type: Object,
        default: {
          subject_name: '',
          child: []
        }
      }
    },
    data() {
      return {
        select: {
          subject_name: '',
          child: []
        },
        goodsType: 1
      }
    },
    mounted() {
    //   console.log(this.$route.name)
      // 纸电同步 - goodsType：2电子书
      if (this.$route.name === 'BookElectron') {
        this.goodsType = 2
      } else {
        this.goodsType = 1
      }
    //   console.log(this.goodsType)
    },
    methods: {
      itemClickHandler(item) {
        let params = {
            gid:'0',
            xuekeTitle: item.subject_name,
            publicType: '', // 大众分类
            cnIbraryType: '', // 中图分类
            subjectId: item.subject_code, // 学科类别
            goodsType: this.goodsType
        };
        if(this.$route.query.hasOwnProperty('activitytag')){
            params.activityTag = this.$route.query.activitytag; //10118        三新现货库存
        }else{
            params.activityTag = '';
        }
        this.$router.push({
          name: 'LookPublishingPagesType',
          query: {obj: JSON.stringify(params)}
        })
      },
      itemArrowClickHandler(item) {
        this.select = item === this.select ? [] : item
      },
      itemIClass(item) {
        return item === this.select ? 'el-icon-caret-top' : 'el-icon-caret-bottom'
      },
      itemActiveClass(item) {
        return {
          active: item.title === this.select.title
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Components/MyListMenuItem.vue